window.theme = window.theme || {};
window.theme.sellingPlanLocked = !1;

document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
});

document.addEventListener("cart:updated", function (evt) {
  try {
    reChargeCartJS();
  } catch (e) {
    window.console.log(e);
  }
});

document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
});

document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
});

document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

document.addEventListener("product:variant-change", function (evt) {
  updateFormLabel(evt.detail.container.querySelector("form"));

  if (!evt.detail.container.querySelector("[data-frequency]")) {
    return;
  };

  if (window.theme.sellingPlanLocked == !0) {
    return (window.theme.sellingPlanLocked = !1);
  }

  if (!evt.detail.variant) return;

  evt.detail.container.querySelectorAll("[data-frequency]").forEach((item) => item.classList.remove("subscription-swatch__radio--active"));


  window.hpVariantsFrequencies[evt.detail.variant.id].forEach((frequency, i) => {
    var activeSellingPlan = evt.detail.container.querySelector(`[data-frequency="${frequency}"] input`);

    if (i == 0) {
      evt.detail.container.querySelectorAll('[data-name="selling_plan"]').forEach((input) => (input.checked = !1));
      activeSellingPlan.checked = !0;
      setTimeout(() => {
        activeSellingPlan.dispatchEvent(new Event("change"));
      }, 100);
    }

    activeSellingPlan.parentElement.classList.add("subscription-swatch__radio--active");
  });
  updateFormLabel(evt.detail.container.querySelector("form"));
});

document.addEventListener("product:quantity-update", function (evt) {
  console.log(evt.detail.quantity, evt.detail.variant);
});

function mapQuantityInputs() {
  const qtyInputs = document.querySelectorAll("[data-hp-quantity-inputs]");
  qtyInputs.forEach((qtyInput) => {
    qtyInput.addEventListener("change", (evt) => {
      var optionValue = document.querySelector("[data-hp-quantity-inputs]:checked").value;
      var optionBtn = document.querySelector(`[data-button-id="${optionValue}"]`);
      if (optionBtn) optionBtn.click();
    });
  });
}

mapQuantityInputs();

function updateFormLabel(item) {
  var form = item.closest(".product__details");
  if (!form.querySelector('[name="subscription"]')) return;

  const buttonLabelEl = form.querySelector('[name="add"][type="submit"] [data-add-to-cart-text]');

  const selectedVariantOption = document.querySelectorAll('[name="id"] option')[document.querySelector('[name="id"]').selectedIndex];

  if (selectedVariantOption.hasAttribute("data-sold-out")) return (buttonLabelEl.innerHTML = window.theme.strings.products.product.soldOut);

  if (form.querySelector('[name="subscription"][value="subscribe"]:checked')) {
    console.log(form.querySelector('[name="subscription"]:checked'));
    buttonLabelEl.innerHTML = window.theme.strings.products.product.subscribe_and_save;
    console.log(buttonLabelEl.innerHTML);
    if (document.querySelector("[data-quick-purchase-button]")) document.querySelector("[data-quick-purchase-button]").innerHTML = window.theme.strings.products.product.subscribe_and_save;
  } else {
    console.log("Elseeee");
    buttonLabelEl.innerHTML = window.theme.strings.products.product.add_to_cart;
    if (document.querySelector("[data-quick-purchase-button]")) document.querySelector("[data-quick-purchase-button]").innerHTML = window.theme.strings.products.product.add_to_cart;
  }
}

(function () {
  // Code for unused for "new subscription widget"
  if (document.querySelector("[data-default-freq] input")) document.querySelector("[data-default-freq] input").checked = !0;

  // Add event listener for selecting between subscription and one time purchase
  document.querySelectorAll('[name="subscription"]').forEach((input) => {
    input.addEventListener("change", onSubscriptionChange);
  });

  function onSubscriptionChange(evt) {
    const form = evt.target.closest(".product__details");
    const frequencyEl = form.querySelector(".subscription-swatch__frequancy");
    const isSubscriped = form.querySelector('[value="subscribe"]').checked;
    const packOption2 = form.querySelector("#Option2");

    if (isSubscriped) {
      form.querySelectorAll('[data-name="selling_plan"]').forEach((input) => input.setAttribute("name", input.dataset.name));
      form.querySelectorAll(".show-one-purchase-only").forEach((item) => item.classList.add("hp-hidden"));
      form.querySelectorAll(".show-subscription-only").forEach((item) => item.classList.remove("hp-hidden"));
    } else {
      form.querySelectorAll('[data-name="selling_plan"]').forEach((input) => input.setAttribute("name", "fake-selling_plan"));
      form.querySelectorAll('[data-name="selling_plan"]').forEach((input) => input.removeAttribute("checked"));
      form.querySelectorAll(".show-subscription-only").forEach((item) => item.classList.add("hp-hidden"));
      form.querySelectorAll(".show-one-purchase-only").forEach((item) => item.classList.remove("hp-hidden"));
    }
    window.theme.sellingPlanLocked = !0;
    form.querySelector("#Option1").dispatchEvent(new Event("change"));
  }

  document.querySelectorAll('[data-name="selling_plan"]').forEach((input) => {
    input.addEventListener("change", onPlanChange);
  });

  function onPlanChange(evt) {
    const form = evt.target.closest(".product__details");
    var packOption1 = form.querySelector("#Option1");
    var packOption2 = form.querySelector("#Option2");

    if (packOption2) {
      // This is for the unused new subscription widget
      var activePlanes = Array.from(form.querySelectorAll(".subscription-swatch__radio--active input"));
      console.log(activePlanes);
      var activePlanIndex = activePlanes.indexOf(evt.target);
      console.log("activePlanIndex:", activePlanIndex);
      packOption2.selectedIndex = activePlanIndex;
      window.theme.sellingPlanLocked = !0;
    }
    /**
     * This has been disabled as it was causing issues with subscription products with two options.
     */
    // packOption1.dispatchEvent(new Event("change"));
  }

  window.addEventListener("load", (event) => {
    if (document.querySelector("[data-quick-purchase-button]")) {
      document.querySelector("[data-quick-purchase-button]").addEventListener("click", (evt) => {
        evt.preventDefault();
        document.querySelector(".product-form__cart-submit").click();
      });
    }

    const quickPurchaseBar = document.querySelector(".quick-purchase-bar");
    if (quickPurchaseBar) {
      document.querySelectorAll('[name="subscription"]').forEach((input) => {
        input.addEventListener("change", (evt) => {
          if (evt.target.value == "subscribe") {
            quickPurchaseBar.classList.add("quick-purchase-bar--subscription-selected");
          } else {
            quickPurchaseBar.classList.remove("quick-purchase-bar--subscription-selected");
          }
        });
      });
    }

    document.querySelectorAll('[href="#add-to-cart"]').forEach((button) => {
      button.addEventListener("click", (evt) => {
        evt.preventDefault();
        if (document.querySelector(".product-form__cart-submit")) {
          document.querySelector(".product-form__cart-submit").click();
        }
      });
    });
    updateActiveSellingPlan();
  });

  document.querySelectorAll('[name="subscription"]').forEach((input) =>
    input.addEventListener("change", (evt) => {
      var target = evt.target || evtcurrentTarget;
      updateFormLabel(target.closest(".product__details"));
    })
  );

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => updateFormLabel(form));

  // Only works for new sub widget
  function updateActiveSellingPlan() {
    if (document.querySelector(".new-sub-widget")) {
      document.querySelectorAll(".product__details").forEach((form) => {
        var packOption2 = form.querySelector("#Option2");
        if (packOption2) {
          form.querySelectorAll('[data-name="selling_plan"]').forEach((input) => (input.checked = !1));
          var activePlanes = Array.from(form.querySelectorAll(".subscription-swatch__radio--active input"));
          var activePlanIndex = packOption2.selectedIndex;
          activePlanes[activePlanIndex].checked = !0;
          activePlanes[activePlanIndex].dispatchEvent(new Event("change"));
        }
      });
    }
  }
  setTimeout(updateActiveSellingPlan, 100);
})();

class HpVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.plus = this.querySelector(".plus");
    this.minus = this.querySelector(".minus");
    this.text = document.querySelectorAll(".hp-variants-selector__text");
    this.variants = document.querySelectorAll(".product__chip");
    this.quantityVariants = document.querySelectorAll(".product__color-chips--quantity .product__chip");
    this.plus.addEventListener("click", this.next.bind(this));
    this.minus.addEventListener("click", this.previous.bind(this));
    this.checkIndex();
  }

  next(e) {
    console.log("Next button has been clicked");
    // Get the selected product chip
    var selectedVariant = document.querySelector(".product__color-chips--quantity .product__chip.selected");

    // Get the selected variant index
    var selectedVariantIndex = parseInt(selectedVariant.getAttribute("data-variant-index"));
    var nextVariant = document.querySelector(`.product__color-chips--quantity .product__chip[data-variant-index = '${selectedVariantIndex + 1}' ]`);
    if (nextVariant) {
      nextVariant.click();
      this.text.forEach((t) => {
        t.innerText = nextVariant.getAttribute("data-button");
      });
    }
    this.checkIndex();
  }

  previous(e) {
    var selectedVariant = document.querySelector(".product__color-chips--quantity .product__chip.selected");
    var selectedVariantIndex = parseInt(selectedVariant.getAttribute("data-variant-index"));
    var previousVariant = document.querySelector(`.product__color-chips--quantity .product__chip[data-variant-index = '${selectedVariantIndex - 1}' ]`);
    if (previousVariant) {
      previousVariant.click();
      this.text.forEach((t) => {
        t.innerText = previousVariant.getAttribute("data-button");
      });
    }
    this.checkIndex();
  }

  checkIndex() {
    this.quantityVariants.forEach((variant) => {
      if (variant.classList.contains("selected")) {
        var selectedIndex = variant.getAttribute("data-variant-index");
        var minIndex = 1;
        var maxIndex = document.querySelector(".hp-variants-selector__text").getAttribute("data-max-index");
        var minuses = document.querySelectorAll(".hp-variants-selector__btn.minus");
        var pluses = document.querySelectorAll(".hp-variants-selector__btn.plus");
        if (selectedIndex == minIndex) {
          minuses.forEach((minus) => {
            minus.setAttribute("data-disabled", "");
          });
        } else if (selectedIndex == maxIndex) {
          pluses.forEach((plus) => {
            plus.setAttribute("data-disabled", "");
          });
        } else {
          minuses.forEach((minus) => {
            minus.removeAttribute("data-disabled");
          });
          pluses.forEach((plus) => {
            plus.removeAttribute("data-disabled");
          });
        }
      }
    });
  }
}

customElements.define("hp-variant-selector", HpVariantSelector);